export default "__VITE_ASSET__624e5be6__";